import { render, staticRenderFns } from "./ChangePassWord.vue?vue&type=template&id=a539a21e&scoped=true&"
import script from "./ChangePassWord.vue?vue&type=script&lang=js&"
export * from "./ChangePassWord.vue?vue&type=script&lang=js&"
import style0 from "./ChangePassWord.vue?vue&type=style&index=0&id=a539a21e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a539a21e",
  null
  
)

export default component.exports